<template>
    <div class="ath-loader-bar"></div>
</template>

<script>
export default {
    name: 'mead-loader-bar',
};

</script>

<style lang="scss" scoped>
@import '../../../sass/variables';

$athloader-bar-w: 10rem;

.ath-loader-bar {
    width: $athloader-bar-w;
    height: .4rem;
    background-color: var(--c-brand-default-bg);
    position: relative;
    overflow: hidden;
    border-radius: 1rem;

    &:before {
        display: block;
        width: 3rem;
        height: inherit;
        position: absolute;
        content: '';
        left: calc(-#{$athloader-bar-w} * 2);
        background-color: var(--c-brand-main);
        border-radius: inherit;
        animation: curvePositionLTR 1s linear infinite;
    }
}
</style>
